module.exports = __webpack_public_path__ + "static/media/pic3.b181c227.webp";